import { Center, Modal, Checkbox, Box, HStack, VStack } from 'native-base';
import { Caption, H3 } from './Typography';
import React, { useState } from 'react';
import { useGeneralStyles, useFormStyles, useStoreStyles } from '~/shared/styles';
import Button from '~/shared/Button';
import { useUpdateMember, useSpringBigStore, useI18n } from '@springbig/shared';
import Pressable from '~/shared/Pressable';

const WalletTerms = ({ }) => {
    const { member, theme } = useSpringBigStore();

    const gStyle = useGeneralStyles();
    const { input_checkbox_background } = useFormStyles();
    const {
        link_text
    } = useStoreStyles();
    const { t } = useI18n();


    const [formData, setData] = useState<boolean>(!!member?.wallet_terms);

    const { mutate: updateMember, isLoading, data: memberUpdated } = useUpdateMember();
    const onSubmit = (): void => {
        updateMember({
            member: {
                wallet_terms: formData
            }
        });
    };

    const handleLinkPress = (url: string): void => {
        if (!url) {
            return;
        }

        window.open(url, '_blank');
    };

    return member && (
        <Center>
            <Modal isOpen overflowY={'auto'}>
                <Modal.Content>
                    <Modal.Header>
                        {member.merchant_name}
                    </Modal.Header>
                    <Modal.Body>
                        <Box>
                            <H3>{ t('profileMenu.terms_condition') }</H3>
                            <Caption>
                                Tap the link below to read through our updated { t('profileMenu.terms_condition') }. By
                                checking the box, you acknowledge that you have read and agree to the following terms:
                            </Caption>
                        </Box>
                        <Center>
                            <Box flexDirection={'row'} my={5} alignItems={'center'}>
                                <Checkbox
                                    isChecked={formData}
                                    value={formData.toString()}
                                    onChange={(formData) => {
                                        setData(formData);
                                    }}
                                    _checked={{
                                        value: '',
                                        bg: input_checkbox_background
                                    }}
                                    mr={2}
                                />
                                <VStack>
                                    <Pressable onPress={() => handleLinkPress(member.terms_and_conditions_link)} flexDirection={'row'}>
                                        <HStack space={1}>
                                            <Caption>I accept the </Caption>
                                            <Caption color={gStyle.link}>{ t('profileMenu.terms_condition') }</Caption>
                                        </HStack>
                                    </Pressable>
                                    { member.privacy_policy_url &&
                                        <Pressable onPress={() => handleLinkPress(member.privacy_policy_url)} flexDirection={'row'}>
                                            <HStack space={1}>
                                                <Caption>& </Caption>
                                                <Caption color={gStyle.link}>{ t('profileMenu.privacy_policy') }</Caption>
                                            </HStack>
                                        </Pressable>
                                    }
                                </VStack>
                            </Box>
                        </Center>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bg={gStyle.button_background}
                            _text={{
                                color: gStyle.button_text,
                            }}
                            mx={'auto'}
                            h={8}
                            py={2}
                            px={5}
                            onPress={() => onSubmit()}
                        >
                            Agree and Continue
                        </Button>
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        </Center>
    );
};

export default WalletTerms;
